import  { CARGAR_COBRAZA } from './actionTypes';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';
import { get_FechaLocalActual } from '../../funciones_globales/utils';
import { formatearFecha } from '../../funciones_globales/format';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_cobranza = (cobranza_recibo) => {
    return (dispatch) => {
        
        let config_request = {
            method: 'GET',
            url: '/caja/cobranza/'+cobranza_recibo,
        }
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
        .then( response => {
			if(response.data.estado !== 'X'){
				var temp = response.data.fecha_recibo
				response.data.fecha_recibo = formatearFecha(temp);
			}
			dispatch({
				type: CARGAR_COBRAZA,
                data: response.data,	
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cobranza', mensaje: msgError}
			});
		});
    }
}

export const cargar_ValoresIniciales = () => {
	return (dispatch) => {					
		let fecha = get_FechaLocalActual();

		dispatch({
			type: INICIALIZAR_FORM,
			data: {	fecha_caja: fecha }			
		})
	}
}